/**
 * Source-of-truth for the homepage mini-FAQ section.
 * Imported by HomepageFaqJsonLd.tsx (schema + UI) AND by
 * scripts/generate-static-content.ts (static HTML generation).
 */

export interface HomepageFaqItem {
  q: string;
  a: string;
}

export const homepageFaqItems: HomepageFaqItem[] = [
  {
    q: 'Quelles activités indoor peut-on réserver sur FullBook à Paris ?',
    a: "FullBook propose des dizaines d'activités indoor en Île-de-France : bowling, escape game, karting, laser game, padel, quiz room, billard, paintball, trampoline park et VR arcade. Toutes les disponibilités sont affichées en temps réel.",
  },
  {
    q: 'Comment réserver une activité sur FullBook ?',
    a: "Choisissez votre activité, sélectionnez un créneau disponible, indiquez le nombre de participants et payez en ligne en quelques clics. Vous recevez une confirmation par email instantanément.",
  },
  {
    q: 'Peut-on réserver pour un groupe ou un événement sur FullBook ?',
    a: "Oui, FullBook est particulièrement adapté aux réservations en groupe : anniversaires, EVG, EVJF, team building ou simple sortie entre amis. Indiquez le nombre de participants lors de la réservation.",
  },
  {
    q: 'Le paiement est-il sécurisé sur FullBook ?',
    a: "Oui. Les paiements sont traités par Stripe, leader mondial du paiement en ligne. Vos données bancaires ne transitent jamais par nos serveurs. La transaction est chiffrée de bout en bout.",
  },
  {
    q: "FullBook couvre-t-il toute l'Île-de-France ?",
    a: "Oui, FullBook référence des établissements dans tout Paris et sa région : Paris intra-muros, petite et grande couronne (Hauts-de-Seine, Seine-Saint-Denis, Val-de-Marne, Essonne, Val-d'Oise, Yvelines, Seine-et-Marne).",
  },
];
